export const UserAccount = {
  Logout: 'Logout',
  PasswordChange: 'Password change',
  UserAccount: 'User account',
};
